"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppWrapper = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AppWrapper = function (_a) {
    var children = _a.children;
    var _b = (0, react_router_dom_1.useLocation)(), hash = _b.hash, pathname = _b.pathname;
    (0, react_1.useLayoutEffect)(function () {
        var el = document.getElementById(hash.replace("#", ""));
        setTimeout(function () {
            window.scrollTo({
                behavior: el ? "smooth" : "auto",
                top: el ? el.offsetTop : 0
            });
        }, 0);
    }, [hash, pathname]);
    return (react_1.default.createElement("div", { className: "AppWrapper bg-light1 dark1 f2 ff-arial" }, children));
};
exports.AppWrapper = AppWrapper;
